import React from 'react'
import {TaskStatus} from '@modifi/enums'
import {ClearFilter} from '@modifi/ui'

import InfoDropdown from '../info-dropdown'
import {DateFilterWrapper} from '../../../../components/table'
import {DateFilter, TaskStatusFilter, TaskGroupFilter} from '../../../../components/filters'
import {CommonFilterProps} from '../../../../ui/filter'

const FilterRow = () => (
  <>
    <ClearFilter label="Reset all" rejectFiltersFromCount={['SALESFORCE', 'MANUAL_ONBOARDING']} />
    <InfoDropdown
      dropdownContent={TaskGroupFilter}
      dropdownPosition="right"
      dropdownWidth={160}
      filterType="taskGroup"
      filterProperties={['filter.category']}
      totalOptions={3}
    />
    <InfoDropdown
      dropdownContent={(props: CommonFilterProps) => (
        <DateFilterWrapper>
          <DateFilter filterKey="filter.dueDateOn" preferFutureDates {...props} />
        </DateFilterWrapper>
      )}
      dropdownPosition="right"
      dropdownWidth={360}
      filterType="date"
      filterProperties={['filter.dueDateOn.from', 'filter.dueDateOn.to']}
    />
    <InfoDropdown
      dropdownContent={TaskStatusFilter}
      dropdownPosition="right"
      dropdownWidth={160}
      filterType="status"
      filterProperties={['filter.status']}
      totalOptions={Object.keys(TaskStatus).length}
    />
  </>
)

export default FilterRow
